import React from "react";
import "../CSS/Receipt.css";

const Receipt = () => {
    return (
        <div className="receipt-container">
            <div className="receipt-header">
                <span className="back-arrow">&#8592;</span>
                <h2>Withdrawal Receipt</h2>
                <span className="help-icon">?</span>
            </div>

            <div className="user-info">
                <div className="user-icon">⭐</div>
                <div>
                    <div className="user-name">Richard Brown</div>
                    <div className="account-id">Account ID 2784351</div>
                </div>
            </div>

            <div className="section">
                <h4>Amount Requested</h4>
                <div className="amount">₹5,000 INR</div>
                <div className="usd-amount">$60.00 USD</div>
                <div className="exchange-rate">Exchange rate 1 USD = 83.33 INR</div>
            </div>

            <div className="section">
                <h4>Banking Information</h4>
                <div className="bank-detail">HDFC Bank</div>
                <div className="bank-detail">Account **** 1234</div>
                <div className="bank-detail">Richard A. Brown</div>
                <div className="bank-detail">IFSC/SWIFT HDFC0001234</div>
            </div>

            <div className="status-section">
                <span className="status pending">PENDING</span>
            </div>

            <div className="action-buttons">
                <button className="approve">Approve</button>
                <button className="decline">Decline</button>
            </div>

            <button className="view-slip">View Slip</button>
        </div>
    );
};

export default Receipt;